import { put, fork, takeEvery, select } from 'redux-saga/effects'
import { takeLatestAndCancel } from './take'
import makePaginatedListSaga from './paginated'
import { authApiCall } from './helpers'

import {
  notifySuccess,
  notifyFailure,
  GET_SWAPS,
  GET_SWAP_DETAIL,
  GET_SWAP_DETAIL_LOADING,
  GET_SWAP_DETAIL_SUCCESS,
  GET_SWAP_DETAIL_FAILURE,
  GET_SWAP_DETAIL_UNLOAD,
  SWAP_ACTION_ACCEPT,
  SWAP_ACTION_ACCEPT_SUCCESS,
  SWAP_ACTION_ACCEPT_FAILURE,
  SWAP_ACTION_ACCEPT_LOADING,
  SWAP_ACTION_HIDE,
  SWAP_ACTION_HIDE_SUCCESS,
  SWAP_ACTION_HIDE_FAILURE,
  SWAP_ACTION_HIDE_LOADING,
  SWAP_ACTION_REJECT,
  SWAP_ACTION_REJECT_SUCCESS,
  SWAP_ACTION_REJECT_FAILURE,
  SWAP_ACTION_REJECT_LOADING,
  SWAP_ACTION_CANCEL,
  SWAP_ACTION_CANCEL_SUCCESS,
  SWAP_ACTION_CANCEL_FAILURE,
  SWAP_ACTION_CANCEL_LOADING,
  SWAP_ACTION_FEEDBACK,
  SWAP_ACTION_FEEDBACK_LOADING,
  SWAP_ACTION_FEEDBACK_SUCCESS,
  SWAP_ACTION_FEEDBACK_FAILURE,
  SWAP_ACTION_ARCHIVE,
  SWAP_ACTION_ARCHIVE_LOADING,
  SWAP_ACTION_ARCHIVE_SUCCESS,
  SWAP_ACTION_ARCHIVE_FAILURE,
  GET_NEW_SWAP_DATA,
  GET_NEW_SWAP_DATA_LOADING,
  GET_NEW_SWAP_DATA_SUCCESS,
  GET_NEW_SWAP_DATA_FAILURE,
  GET_NEW_SWAP_DATA_UNLOAD,
  CREATE_NEW_SWAP,
  CREATE_NEW_SWAP_LOADING,
  CREATE_NEW_SWAP_SUCCESS,
  CREATE_NEW_SWAP_FAILURE,
  UPDATE_SWAP,
  UPDATE_SWAP_LOADING,
  UPDATE_SWAP_SUCCESS,
  UPDATE_SWAP_FAILURE,
  REFRESH_LOGGED_USER_COUNTS,
} from '../actions'

import * as api from '../api'

function* handleGetSwapDetail({ payload }) {
  const swapId = payload
  yield put({ type: GET_SWAP_DETAIL_LOADING })
  try {
    const swap = yield authApiCall(api.getSwapDetail, swapId)
    yield put({ type: GET_SWAP_DETAIL_SUCCESS, payload: swap })
  } catch (error) {
    yield put({ type: GET_SWAP_DETAIL_FAILURE, error })
  }
}

function* refreshSwap(swapId) {
  const refreshedSwap = yield authApiCall(api.getSwapDetail, swapId)
  yield put({ type: UPDATE_SWAP_SUCCESS, payload: refreshedSwap })
  return refreshedSwap
}

function* handleAcceptSwap({ payload: { swapId, updatedAt } }) {
  yield put({ type: SWAP_ACTION_ACCEPT_LOADING, payload: { swapId } })
  try {
    yield authApiCall(api.acceptSwap, swapId, updatedAt)
    yield put({ type: SWAP_ACTION_ACCEPT_SUCCESS, payload: { swapId } })
    yield put({ type: REFRESH_LOGGED_USER_COUNTS, payload: ['newSwaps'] })
  } catch (error) {
    // Conflict \w current server state refresh swap and notify user
    if (error.status === 409) {
      try {
        yield refreshSwap(swapId)
        yield put(
          notifySuccess({
            message: 'Attenzione proposta modificata, valuta la nuova proposta prima di accettare.',
            timeout: 3000,
          })
        )
      } catch (error) {
        yield put(
          notifyFailure({
            message: 'Attenzione proposta modificata, ricarica la pagina per vedere la nuova proposta.',
            timeout: 3000,
          })
        )
      }
    }
    yield put({ type: SWAP_ACTION_ACCEPT_FAILURE, payload: { swapId }, error })
  }
}

function* handleHideSwap({ payload: { swapId } }) {
  yield put({ type: SWAP_ACTION_HIDE_LOADING, payload: { swapId } })
  try {
    yield authApiCall(api.hideSwap, swapId)
    yield put({ type: SWAP_ACTION_HIDE_SUCCESS, payload: { swapId } })
  } catch (error) {
    yield put({ type: SWAP_ACTION_HIDE_FAILURE, payload: { swapId }, error })
  }
}

function* handleRejectSwap({ payload: { swapId, reason, updatedAt } }) {
  yield put({ type: SWAP_ACTION_REJECT_LOADING, payload: { swapId } })
  try {
    yield authApiCall(api.rejectSwap, swapId, reason, updatedAt)
    yield put({ type: SWAP_ACTION_REJECT_SUCCESS, payload: { swapId } })
    yield put({ type: REFRESH_LOGGED_USER_COUNTS, payload: ['newSwaps'] })
  } catch (error) {
    // Conflict \w current server state refresh swap and notify user
    if (error.status === 409) {
      try {
        yield refreshSwap(swapId)
        yield put(
          notifySuccess({
            message: 'Attenzione proposta modificata, valuta la nuova proposta prima di rifiutare.',
            timeout: 3000,
          })
        )
      } catch (error) {
        yield put(
          notifyFailure({
            message: 'Attenzione proposta modificata, ricarica la pagina per vedere la nuova proposta.',
            timeout: 3000,
          })
        )
      }
    }
    yield put({ type: SWAP_ACTION_REJECT_FAILURE, payload: { swapId }, error })
  }
}

function* handleCancelSwap({ payload: { swapId } }) {
  yield put({ type: SWAP_ACTION_CANCEL_LOADING, payload: { swapId } })
  try {
    yield authApiCall(api.cancelSwap, swapId)
    yield put({ type: SWAP_ACTION_CANCEL_SUCCESS, payload: { swapId } })
  } catch (error) {
    yield put({ type: SWAP_ACTION_CANCEL_FAILURE, payload: { swapId }, error })
  }
}

function* handleFeedbackSwap({ payload: { swapId, userId, rating, reason } }) {
  yield put({ type: SWAP_ACTION_FEEDBACK_LOADING, payload: { swapId } })
  try {
    yield authApiCall(api.feedbackSwap, swapId, rating, reason)
    yield put({
      type: SWAP_ACTION_FEEDBACK_SUCCESS,
      payload: { swapId, userId, rating, reason },
    })
  } catch (error) {
    yield put({
      type: SWAP_ACTION_FEEDBACK_FAILURE,
      payload: { swapId },
      error,
    })
  }
}

function* handleArchiveSwap({ payload: { swapId, userId } }) {
  yield put({ type: SWAP_ACTION_ARCHIVE_LOADING, payload: { swapId } })
  try {
    yield authApiCall(api.archiveSwap, swapId)
    yield put({
      type: SWAP_ACTION_ARCHIVE_SUCCESS,
      payload: { swapId, userId },
    })
  } catch (error) {
    yield put({ type: SWAP_ACTION_ARCHIVE_FAILURE, payload: { swapId }, error })
  }
}

function* handleGetNewSwapData({
  payload: { destinatarioId, destinatarioItemsIds, proponenteItemsIds, money },
}) {
  yield put({ type: GET_NEW_SWAP_DATA_LOADING })
  try {
    const destinatario = yield authApiCall(api.getUserInfo, destinatarioId)
    const proponente = yield select(state => state.auth.user) // <--- It's me!

    const destinatarioItems = yield destinatarioItemsIds.map(itemId =>
      authApiCall(api.getItemDetail, itemId, {
        user_id: destinatarioId,
      })
    )

    const proponenteItems = yield proponenteItemsIds.map(itemId =>
      authApiCall(api.getItemDetail, itemId, {
        user_id: proponente.id,
      })
    )

    yield put({
      type: GET_NEW_SWAP_DATA_SUCCESS,
      payload: {
        proponenteMoney: money,
        destinatario,
        proponente,
        destinatarioItems,
        proponenteItems,
      },
    })
  } catch (error) {
    yield put({ type: GET_NEW_SWAP_DATA_FAILURE, error })
  }
}

const makeSwapForApi = swap => ({
  user_from: {
    id: swap.proponente.id,
    ecoin: swap.proponenteMoney,
    items: swap.proponenteItemsIds,
  },
  user_to: {
    id: swap.destinatario.id,
    ecoin: swap.destinatarioMoney,
    items: swap.destinatarioItemsIds,
  },
})

function* handleCreateNewSwap({ payload, successMessage }) {
  const swap = payload
  yield put({ type: CREATE_NEW_SWAP_LOADING })
  try {
    const createdSwap = yield authApiCall(
      api.createNewSwap,
      makeSwapForApi(swap)
    )
    yield put({ type: CREATE_NEW_SWAP_SUCCESS, payload: createdSwap })
    if (successMessage) {
      yield put(notifySuccess({ message: successMessage }))
    }
  } catch (error) {
    yield put({ type: CREATE_NEW_SWAP_FAILURE, error })
  }
}

function* handleUpdateSwap({ payload }) {
  const { swap, reversed } = payload
  yield put({ type: UPDATE_SWAP_LOADING })
  try {
    if (reversed) {
      const createdSwap = yield authApiCall(
        api.createNewSwap,
        makeSwapForApi(swap)
      )
      yield authApiCall(
        api.rejectSwap,
        swap.id,
        `Rifiuto per controproposta to:/swap/${createdSwap.id}`
      )
      yield put({ type: UPDATE_SWAP_SUCCESS, payload: createdSwap })
      yield put({ type: REFRESH_LOGGED_USER_COUNTS, payload: ['newSwaps'] })
    } else {
      const updatedSwap = yield authApiCall(
        api.updateSwap,
        swap.id,
        makeSwapForApi(swap)
      )
      yield put({ type: UPDATE_SWAP_SUCCESS, payload: updatedSwap })
    }
  } catch (error) {
    yield put({ type: UPDATE_SWAP_FAILURE, error })
  }
}

// Saga of swaps
export default function* swaps() {
  yield fork(
    makePaginatedListSaga(GET_SWAPS, api.getSwaps, state => state.swaps)
  )
  yield fork(
    takeLatestAndCancel,
    GET_SWAP_DETAIL,
    GET_SWAP_DETAIL_UNLOAD,
    handleGetSwapDetail
  )
  yield fork(
    takeLatestAndCancel,
    GET_NEW_SWAP_DATA,
    GET_NEW_SWAP_DATA_UNLOAD,
    handleGetNewSwapData
  )
  yield takeEvery(SWAP_ACTION_ACCEPT, handleAcceptSwap)
  yield takeEvery(SWAP_ACTION_HIDE, handleHideSwap)
  yield takeEvery(SWAP_ACTION_REJECT, handleRejectSwap)
  yield takeEvery(SWAP_ACTION_CANCEL, handleCancelSwap)
  yield takeEvery(SWAP_ACTION_FEEDBACK, handleFeedbackSwap)
  yield takeEvery(SWAP_ACTION_ARCHIVE, handleArchiveSwap)
  yield takeEvery(CREATE_NEW_SWAP, handleCreateNewSwap)
  yield takeEvery(UPDATE_SWAP, handleUpdateSwap)
}



// WEBPACK FOOTER //
// ./src/saga/swaps.js